module.exports = __webpack_public_path__ + "img/video.27326ae0.svg";